type NativeSecureStorage = {
    get(key: string): string | Promise<string>;
    set(key: string, value: string): void | Promise<void>;
    remove(key: string): void | Promise<void>;
};

export class SecureStorage {
    private static readonly PREFIX = "adfarm-secure:";

    private static bridge(): NativeSecureStorage | null {
        const host = globalThis as unknown as { AdFarmNativeBridge?: { secureStorage?: NativeSecureStorage } };
        return host.AdFarmNativeBridge?.secureStorage || null;
    }

    static async get(key: string): Promise<string> {
        const bridge = this.bridge();
        if (bridge) return (await bridge.get(key)) || "";
        return Laya.LocalStorage.getItem(this.PREFIX + key) || "";
    }

    static async set(key: string, value: string): Promise<void> {
        const bridge = this.bridge();
        if (bridge) {
            await bridge.set(key, value);
            return;
        }
        Laya.LocalStorage.setItem(this.PREFIX + key, value);
    }

    static async remove(key: string): Promise<void> {
        const bridge = this.bridge();
        if (bridge) {
            await bridge.remove(key);
            return;
        }
        Laya.LocalStorage.removeItem(this.PREFIX + key);
    }
}
